// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TableSortLabel,
// } from "@material-ui/core";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import { makeStyles } from "@material-ui/styles";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableSortLabel from "@mui/material/TableSortLabel";
import TableRow from "@mui/material/TableRow";
import SortAscending from "../../../assets/icons/SortAscending.svg";
import "./newtable.scss";
import React, { useContext, useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import { Fragment } from "react";
import { getTableList } from "../../../constants/mapping";
import { BootstrapTooltip } from "../ActionColumn";
import { LoaderContext } from "../../../gatekeeper";
import { Checkbox } from "@material-ui/core";
import FooterPagination from "../FooterPagination";
import { currentCount } from "../../../services/apiRequestMethods";
import {
  calculatePageNumberFromOffset,
  objectHasKeysCheck,
} from "../../../services/commonMethods";

// import filterIcon from '../../../../src/assets/icons/filter.svg';
// import UsersList from "../../containers/Users-CRUD/UsersList";
// import SearchIcon from '@material-ui/icons/Search';

export const TABLE_COLUMN_IDS = {
  CHECKBOX_ID: "checkbox",
  SELECTED_ID: "selected",
};

function FilterIcon(props) {
  return (
    <div>
      <img
        src={SortAscending}
        alt={`Image`}
        style={{
          marginLeft: "8px",
          width: "20px",
          height: "20px",
          transform: `${props.sortDir === "desc" ? "" : "rotate(180deg)"}`,
        }}
      />
    </div>
  );
}

export default function CustomNewTable(props) {
  // const [anchorEl, setAnchorEl] = React.useState(null);
  // const [checked, setChecked] = React.useState(true);
  let {
    tableHead,
    tableData,
    customRowEnabled,
    refr,
    sortableProps,
    selectedRows,
    setSelectedRows,
    selectedRowKey,
    paginationParams,
    paginationItemsTitle,
    paginationEnabled,
    rawTableData,
    disableLastRow,
    customTableRow,
  } = props;

  //If limit=-1, then change it to 10.
  if (paginationEnabled && !~paginationParams.limit) {
    paginationParams.limit = 10;
  }

  const [dataKeys, setDataKeys] = useState(refr);

  //returns payload for api.
  function getPaginationPayload(nextParams) {
    return { ...paginationParams, ...nextParams };
  }

  useEffect(() => {
    let dataKeys = getTableList(refr);

    //Gate to insert checkbox into dataKeys
    if (props.checkboxEnabled) {
      dataKeys = [TABLE_COLUMN_IDS.CHECKBOX_ID, ...dataKeys];
    }

    //Remove action column from dataKeys if action is not passed in head.
    //This prevents extra space on table.
    if (!tableHead.checkIfKeyValueExists("title", "Action")) {
      dataKeys = dataKeys.filter((ele) => ele !== "action");
    }
    setDataKeys(dataKeys);
  }, [refr]);

  const context = useContext(LoaderContext);

  const changeInPagination = (type, pageNumber, ev) => {
    if (type === "limit") {
      //Reset page in case of limit change.
      return props.requestPaginationData(
        getPaginationPayload({
          limit: ev.target.value,
          currentPage: 1,
          offset: 0,
        })
      );
    } else {
      return props.requestPaginationData(
        getPaginationPayload({
          currentPage: pageNumber,
          offset: (parseInt(pageNumber) - 1) * parseInt(paginationParams.limit),
        })
      );
    }
  };

  // useEffect(() => {
  //   const element = document.getElementById("table_ref");
  //   if (element) {
  //     element.scrollTo(0, 0);
  //   }
  //   element.scrollTo(0, 0);
  // }, [tableData]);

  const handleTableHeadCheckbox = function (ev) {
    const {
      target: { checked },
    } = ev;
    let nextSelectedRows = [];
    if (checked) {
      let currentSelectedRows = rawTableData
        .map((ele) => {
          if (!selectedRows.checkIfKeyValueExists("id", ele.id)) {
            //Only return the rows which are not already selected
            return {
              ...ele,
              [TABLE_COLUMN_IDS.SELECTED_ID]: true,
            };
          } else {
            return undefined;
          }
        })
        .filter((ele) => ele);
      nextSelectedRows = [...selectedRows, ...currentSelectedRows];
    } else {
      let currentSelectedRows = selectedRows.filter(
        (row) => !rawTableData.checkIfKeyValueExists("id", row.id)
      );

      nextSelectedRows = currentSelectedRows;
    }
    return setSelectedRows(nextSelectedRows);
  };

  const handleRowCheckbox = function (ev, json) {
    let element = rawTableData.find(
      (ele) => ele[selectedRowKey] === json[selectedRowKey]
    );
    let nextSelectedRows;
    const {
      target: { checked },
    } = ev;
    if (checked) {
      nextSelectedRows = [
        ...selectedRows,
        { ...element, [TABLE_COLUMN_IDS.SELECTED_ID]: true },
      ];
    } else {
      nextSelectedRows = selectedRows.filter(
        (ele) => ele[selectedRowKey] !== element[selectedRowKey]
      );
    }
    return setSelectedRows(nextSelectedRows);
  };
  const useStyles = makeStyles({
    tableContainer: {
      overflowY: "auto",
    },
    table: {
      height: "100%",
      overflowY: "scroll",
    },
    // hideLastBorder: {
    //   "&:last-child td, &:last-child th": {
    //     border: 0
    //   }
    // }
    //className={classes.hideLastBorder}
  });

  //Renders chekboxes in table to select rows.
  const formCheckbox = (value, onChange) => {
    return (
      <Checkbox
        checked={value}
        value={value}
        size="small"
        classes={{
          root: "permission-checkbox",
          checked: "permission-checkbox-checked",
        }}
        onChange={onChange}
      />
    );
  };

  function checkAllRowsAreSelected(tableData, selectedRows) {
    if (customRowEnabled) {
      return tableData.slice(1).every(function (json) {
        return selectedRows.checkIfKeyValueExists(
          selectedRowKey,
          json[selectedRowKey]
        );
      });
    } else if (disableLastRow) {
      return tableData.slice(0, -1).every(function (json) {
        return selectedRows.checkIfKeyValueExists(
          selectedRowKey,
          json[selectedRowKey]
        );
      });
    } else {
      return tableData.every(function (json) {
        return selectedRows.checkIfKeyValueExists(
          selectedRowKey,
          json[selectedRowKey]
        );
      });
    }
  }

  if (props.checkboxEnabled) {
    tableHead = [
      {
        title: formCheckbox(
          checkAllRowsAreSelected(tableData, selectedRows),
          handleTableHeadCheckbox
        ),
      },
      ...tableHead,
    ];

    tableData = tableData.map((json) => {
      json[TABLE_COLUMN_IDS.SELECTED_ID] = selectedRows.checkIfKeyValueExists(
        selectedRowKey,
        json[selectedRowKey]
      );
      json[TABLE_COLUMN_IDS.CHECKBOX_ID] = (
        <TableCell
          style={{ pointerEvents: json.rowDisabled ? "none" : "auto" }}
        >
          {!json.checkboxDisabled &&
            formCheckbox(json[TABLE_COLUMN_IDS.SELECTED_ID], (ev) =>
              handleRowCheckbox(ev, json)
            )}
        </TableCell>
      );
      return json;
    });
  }

  return (
    <React.Fragment>
      <div className="table-responsive">
        <TableContainer
          classes={{
            root: "dynamic_table_height",
          }}
          id="table_ref"
          // sx={{
          //   maxHeight: {
          //     sm: 250, // theme.breakpoints.up('sm')
          //     md: 350, // theme.breakpoints.up('md')
          //     lg: 510, // theme.breakpoints.up('lg')
          //     xl: 600, // theme.breakpoints.up('xl')
          //   },
          // }}
        >
          <Table
            stickyHeader
            aria-label="sticky table"
            className="custom-new-table"
          >
            {/* stickyHeader aria-label="sticky table" */}
            <TableHead className="custom-new-table-head">
              <TableRow>
                {tableHead.map((head, index) => {
                  const { title, props } = head;
                  return (
                    <TableCell {...props} key={index}>
                      {props && props.sortable ? (
                        <Fragment>
                          <TableSortLabel
                            // active={props.name === sortableProps.sortBy}
                            active="true"
                            direction={sortableProps.sortDir}
                            IconComponent={() => (
                              <FilterIcon sortDir={sortableProps.sortDir} />
                            )}
                            onClick={() => sortableProps.method(props.name)}
                          >
                            {title}
                          </TableSortLabel>
                        </Fragment>
                      ) : (
                        title
                      )}
                      {/* </div> */}
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {tableData.length ? (
                tableData.map((data, index) =>
                  data.tooltipOnRow ? (
                    <BootstrapTooltip
                      title={data.tooltipText}
                      placement="top"
                      key={index}
                    >
                      <TableRow
                        className={"tooltip-row " + (data.rowClass || "")}
                        style={{
                          background: data.tooltipColor || "inherit",
                        }}
                      >
                        {dataKeys[0] ? (
                          data[dataKeys[0]]
                        ) : (
                          <TableCell style={{ display: "none" }} />
                        )}
                        {dataKeys[1] ? (
                          data[dataKeys[1]]
                        ) : (
                          <TableCell style={{ display: "none" }} />
                        )}
                        {dataKeys[2] ? (
                          data[dataKeys[2]]
                        ) : (
                          <TableCell style={{ display: "none" }} />
                        )}
                        {dataKeys[3] ? (
                          data[dataKeys[3]]
                        ) : (
                          <TableCell style={{ display: "none" }} />
                        )}
                        {dataKeys[4] ? (
                          data[dataKeys[4]]
                        ) : (
                          <TableCell style={{ display: "none" }} />
                        )}
                        {dataKeys[5] ? (
                          data[dataKeys[5]]
                        ) : (
                          <TableCell style={{ display: "none" }} />
                        )}
                        {dataKeys[6] ? (
                          data[dataKeys[6]]
                        ) : (
                          <TableCell style={{ display: "none" }} />
                        )}
                        {dataKeys[7] ? (
                          data[dataKeys[7]]
                        ) : (
                          <TableCell style={{ display: "none" }} />
                        )}
                        {dataKeys[8] ? (
                          data[dataKeys[8]]
                        ) : (
                          <TableCell style={{ display: "none" }} />
                        )}
                      </TableRow>
                    </BootstrapTooltip>
                  ) : (
                    <TableRow
                      key={index}
                      className={data.rowClasses ? data.rowClasses : ""}
                    >
                      {dataKeys[0] ? (
                        data[dataKeys[0]]
                      ) : (
                        <TableCell style={{ display: "none" }} />
                      )}
                      {dataKeys[1] ? (
                        data[dataKeys[1]]
                      ) : (
                        <TableCell style={{ display: "none" }} />
                      )}
                      {dataKeys[2] ? (
                        data[dataKeys[2]]
                      ) : (
                        <TableCell style={{ display: "none" }} />
                      )}
                      {dataKeys[3] ? (
                        data[dataKeys[3]]
                      ) : (
                        <TableCell style={{ display: "none" }} />
                      )}
                      {dataKeys[4] ? (
                        data[dataKeys[4]]
                      ) : (
                        <TableCell style={{ display: "none" }} />
                      )}
                      {dataKeys[5] ? (
                        data[dataKeys[5]]
                      ) : (
                        <TableCell style={{ display: "none" }} />
                      )}
                      {dataKeys[6] ? (
                        data[dataKeys[6]]
                      ) : (
                        <TableCell style={{ display: "none" }} />
                      )}
                      {dataKeys[7] ? (
                        data[dataKeys[7]]
                      ) : (
                        <TableCell style={{ display: "none" }} />
                      )}
                      {dataKeys[8] ? (
                        data[dataKeys[8]]
                      ) : (
                        <TableCell style={{ display: "none" }} />
                      )}
                      {dataKeys[9] ? (
                        data[dataKeys[9]]
                      ) : (
                        <TableCell style={{ display: "none" }} />
                      )}
                      {dataKeys[10] ? (
                        data[dataKeys[10]]
                      ) : (
                        <TableCell style={{ display: "none" }} />
                      )}
                      {dataKeys[11] ? (
                        data[dataKeys[11]]
                      ) : (
                        <TableCell style={{ display: "none" }} />
                      )}
                      {dataKeys[12] ? (
                        data[dataKeys[12]]
                      ) : (
                        <TableCell style={{ display: "none" }} />
                      )}
                      {dataKeys[13] ? (
                        data[dataKeys[13]]
                      ) : (
                        <TableCell style={{ display: "none" }} />
                      )}
                      {dataKeys[14] ? (
                        data[dataKeys[14]]
                      ) : (
                        <TableCell style={{ display: "none" }} />
                      )}
                      {dataKeys[15] ? (
                        data[dataKeys[15]]
                      ) : (
                        <TableCell style={{ display: "none" }} />
                      )}
                      {dataKeys[16] ? (
                        data[dataKeys[16]]
                      ) : (
                        <TableCell style={{ display: "none" }} />
                      )}
                    </TableRow>
                  )
                )
              ) : (
                <TableRow>
                  {tableData.length === 0 && !context ? (
                    <TableCell
                      colSpan={dataKeys.length}
                      className="text-center"
                    >
                      No Data Available
                    </TableCell>
                  ) : (
                    <TableCell
                      colSpan={dataKeys.length}
                      className="text-center load-table"
                    >
                      <ul>
                        <li>Loading</li>
                        <li>.</li>
                        <li>.</li>
                        <li>.</li>
                      </ul>
                    </TableCell>
                  )}
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <div className="mt-3">
        {paginationEnabled && (
          <FooterPagination
            itemProps={{
              value: paginationParams.limit,
              name: "limit",
              onChange: (ev) => changeInPagination("limit", null, ev),
            }}
            title={`${currentCount(
              paginationParams.offset,
              paginationParams.total,
              paginationParams.limit
            )} ${paginationItemsTitle}`}
            paginationProps={{
              activePage: calculatePageNumberFromOffset(paginationParams),
              itemsCountPerPage: parseInt(paginationParams.limit),
              totalItemsCount: parseInt(paginationParams.total),
              onChange: (pageNumber) =>
                changeInPagination("page", pageNumber, null),
            }}
            totalLength={paginationParams.total}
          />
        )}
      </div>
    </React.Fragment>
  );
}
